/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { CourierParcelTable, PrimaryButton } from "../../components";
import { useNavigate, useParams } from "react-router";
import { useParcels } from "../../store/useParcels";
import { ReactComponent as LeftArrow } from "../../assets/icons/arrows/left-arrow.svg";

function CourierParcelScreen() {
  /** Params */
  const params = useParams();
  /** Hooks */
  const navigate = useNavigate();
  const { getAllParcels, hasNextPage, allParcels } = useParcels();
  /** State */
  const [page, setPage] = useState(1);

  const addParcel = () => navigate("/add-parcel");
  const goBack = () => navigate(-1);

  useEffect(() => {
    if (!params?.courierId) return;
    getAllParcels(params?.courierId as string, page, 20);
  }, [params?.courierId]);

  return (
    <div>
      <div className="flex w-full justify-between">
        <div
          onClick={goBack}
          className="flex flex-row items-center cursor-pointer mb-11"
        >
          <LeftArrow className="mr-3 cursor-pointer" />
          <h1 className="font-satoshi text-2xl font-bold text-dark">
            {/* @ts-ignore */}
            {allParcels?.[0]?.courier?.name ?? "Courier"} Parcels
          </h1>
        </div>
        <div className="flex flex-col sm:flex-row justify-end sm:items-center">
          <PrimaryButton
            onClick={addParcel}
            label="Add new Parcel"
            className="h-10 mb-1 sm:mb-0"
          />
        </div>
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!allParcels?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Parcel created yet.
          </p>
        ) : (
          <CourierParcelTable />
        )}
      </div>
      {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              if (!params?.courierId) return;
              setPage(page + 1);
              getAllParcels(params?.courierId as string, page + 1, 20);
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null}
    </div>
  );
}

export default withProtectedRoute(CourierParcelScreen);
